import { Box, Button, Stack } from "@mui/material"
import { OpenInNew as OpenInNewIcon } from '@mui/icons-material'

import { useResearchPreview } from "../container"
import { ResearchProjectResult } from "interface/research"

type ResearchPreviewFooterProps = {
	project: ResearchProjectResult
	container: ReturnType<typeof useResearchPreview>
}
export const ResearchPreviewFooter = ({
	container: {
		currentBunkenNo
	}
}: ResearchPreviewFooterProps) => {
	return (
		<Stack direction="row" padding={1} spacing={1} alignItems='center' flexWrap='wrap' useFlexGap>
			<Button
				variant="contained"
				startIcon={<OpenInNewIcon />}
				onClick={(event) => {
					event.preventDefault()
					window.open(`https://mhlw-grants.niph.go.jp/search?report_no=${currentBunkenNo}`, '_blank')
				}}
			>
				文献番号で検索
			</Button>
			<Box sx={{ flexGrow: 1 }} />
		</Stack>
	)
}